<template>
  <div class="vp-percentage-chart">
    <svg
        :width="sideLength"
        :height="sideLength"
        :viewBox="`0 0 ${sideLength} ${sideLength}`"
        class="vp-svg"
    >
      <circle
          class="base-circle"
          :cx="halfSide"
          :cy="halfSide"
          :r="radius"
      />
      <circle
          class="actual-circle"
          :style="circleStyle"
          :cx="halfSide"
          :cy="halfSide"
          :r="radius"
      />
      <text
          x="50%"
          y="50%"
          text-anchor="middle"
          dy=".3em"
          class="percent"
      >
        {{ displayedPercent }}%
      </text>
    </svg>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type Props = {
  percent: number;
};

const props = defineProps<Props>();

const radius = 30;
const circumference = 2 * Math.PI * radius;
const halfSide = computed(() => radius + 10);
const sideLength = computed(() => halfSide.value * 2);

const displayedPercent = computed(() => Math.min(100, Math.max(0, props.percent)));

const circleStyle = computed(() => {
  const offset = circumference - (displayedPercent.value / 100) * circumference;
  return {
    strokeDasharray: `${circumference} ${circumference}`,
    strokeDashoffset: offset,
  };
});
</script>
